import type { ReactNode } from "react";

import { Card, CardDescription, CardHeader } from "@/components/ui/card";

export type AppSettingsCardProps = {
  children: ReactNode;
  title: string;
  description: string;
};

export const AppSettingsCard = ({
  children,
  title,
  description,
}: Readonly<AppSettingsCardProps>) => {
  return (
    <Card>
      <CardHeader className="border-b border-gray-200 p-4">{title}</CardHeader>
      <CardDescription className="p-4">
        <div className="flex w-full flex-row space-x-4">
          <div className="flex-grow text-sm text-gray-400">{description}</div>
          <div className="flex-grow-0">{children}</div>
        </div>
      </CardDescription>
    </Card>
  );
};
